import { workersPoolsService } from 'ogp/services';
import { useQuery } from 'react-query';
import { FirstParamOfFn } from '@types';
import { QUERY_KEYS } from 'api/query-keys';

export const useGetExternalFlexPools = (
  params: FirstParamOfFn<typeof workersPoolsService.getWorkersPools>
) => {
  const queryFn = async () => await workersPoolsService.getWorkersPools(params);

  return useQuery(QUERY_KEYS.flexPoolExternalListWithParams(), queryFn, {
    keepPreviousData: true,
  });
};
